import { CmsComponentTypeEnum } from '@models/enums/cms-component-type.enum';
import { TImageConfig, LinkObject } from '@models/interfaces';
import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';

export namespace Card {
  export const TypeEnum = CmsComponentTypeEnum.CTA;

  export interface ComponentConfig extends BaseComponentConfig {
    cacheKey?: string;
    skeleton?: boolean;
    invalid?: boolean;
    taxonomy?: string;
    headline: string;
    excerpt?: string;
    imageConfig?: TImageConfig;
    marked?: boolean;
    link: LinkObject;
    sticky?: boolean;
    metas?: {
      publishedAt: Date;
      readTime?: string;
    };
  }
}
